import { Icon } from '@ps/isp-web-component-library';
import { ChevronMediumUp } from '@ps/isp-web-component-library/icons/ChevronMediumUp';
import { Size } from '@ps/web-core-enums';
import { useScreenSize } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import { TXTWCL_Close_Bet_Slip, TXTWCL_Open_Bet_Slip } from './BetSlipHeader.messages.json';
import styles from './BetSlipHeader.scss';
import BetSlipHeaderContent from './components/BetSlipHeaderContent/BetSlipHeaderContent';

const BetSlipHeader: React.FC = () => {
  const { betSlip } = useDispatch<Dispatch>();
  const { greaterThan } = useScreenSize();
  const isSmallScreen = !greaterThan(Size.Small);

  const isOpen = useSelector(select.betSlip.isOpen);
  const { formatMessage } = useRegulatoryIntl();

  return (
    <div
      className={styles.container}
      {...(isSmallScreen && {
        role: 'button',
        tabIndex: 0,
        onClick: () => betSlip.betSlipOpened(!isOpen),
        'aria-label': isOpen
          ? formatMessage(TXTWCL_Close_Bet_Slip)
          : formatMessage(TXTWCL_Open_Bet_Slip)
      })}
    >
      <h2
        className={classNames(styles.header, { [styles.open]: isOpen })}
        data-testid="bet-slip-heading"
      >
        <BetSlipHeaderContent />
      </h2>
      <Icon
        icon={ChevronMediumUp}
        className={classNames(styles.chevronIcon, { [styles.open]: isOpen })}
        size="x1"
      />
    </div>
  );
};

export default BetSlipHeader;
